import { pushType, actionTypes } from "./pushTypes";

const initialState: pushStateType = {
  notifications: [],
  settings: true,
};

type pushStateType = {
  notifications: Array<pushType>;
  settings: boolean;
};

const pushReducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case actionTypes.ADD_PUSH:
      const tempNotificationsAdd = [...state.notifications];
      tempNotificationsAdd.push(payload);
      if (tempNotificationsAdd.length>5) {
        tempNotificationsAdd.shift()
      }
      return {
        ...state,
        notifications: tempNotificationsAdd,
      };
    case actionTypes.DELETE_PUSH:
      const tempNotificationsDel = [...state.notifications];
      const tempIndex = tempNotificationsDel.findIndex(el => el.id === payload);
      tempNotificationsDel.splice(tempIndex, 1);
      return {
        ...state,
        notifications: tempNotificationsDel,
      };
    case actionTypes.SET_SETTINGS:
      return {
        ...state,
        settings: payload
      }
    default:
      return state;
  }
};

export default pushReducer;
